import React, { useEffect, useState } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { useCvContext } from "../Navbar_Empresa_Usuarios";
import { FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material"; // Importar Material-UI
import MenuIcon from '@mui/icons-material/Menu';

/* componentes */
import { Vventas } from "../../../../../components/empresa_uno_comp/ventas/Vventas";
import { Vcotizacion } from "../../../../../components/empresa_uno_comp/ventas/Vcotizacion";
import { Vcaja } from "../../../../../components/empresa_uno_comp/ventas/Vcaja";
import { VventasDia } from "../../../../../components/empresa_uno_comp/ventas/VventasDia";
import { VreporteVentas } from "../../../../../components/empresa_uno_comp/ventas/VreporteVentas";
import { VreporteCaja } from "../../../../../components/empresa_uno_comp/ventas/VreporteCaja";
import { VreporteInventario } from "../../../../../components/empresa_uno_comp/ventas/VreporteInventario";
import { VnotaCaja } from "../../../../../components/empresa_uno_comp/ventas/VnotaCaja";
import { VnotaVentas } from "../../../../../components/empresa_uno_comp/ventas/VnotaVentas";
import { VnotaCotizacion } from "../../../../../components/empresa_uno_comp/ventas/VnotaCotizacion";
import { VnotaTraslado } from "../../../../../components/empresa_uno_comp/ventas/VnotaTraslado";
import { VnotaAnuladas } from "../../../../../components/empresa_uno_comp/ventas/VnotaAnuladas";

/*Documentos*/
import venta from "../../../../../images/venta_verde.png";
import cotizacion from "../../../../../images/cotizacion.png";
import caja from "../../../../../images/caja.png";
import ventadia from "../../../../../images/ventadia.png";
import hoja_naranja from "../../../../../images/hoja_naranja.png";
import hoja_morada from "../../../../../images/hoja_morada.png";
import { VreporteCompras } from "../../../../empresa_uno_comp/ventas/VreporteCompras";
import SelectBranchs from "../../../../empresa_uno_comp/SelectBranchs";
import { Error404, useProveedorCompany } from '../../../../../components';

const array_subdirectorys = [
	"realizar", //0
	"cotizar", //1
	"caja", //2
	"dia", //3
	"reporte", //4
	"caja-reporte", //5
	"compras-reporte", //6
	"inventario-reporte", //7
	"caja-nota", //8
	"nota", //9
	"cotizacion-nota", //10
	"traslado-nota", //11
	"anulados", //12
]; //JAMAS TOCAR ESTO SIN PERMISO DEL JEFE DE SISTEMAS

export const Reportes_EU = ({ sucursal_selected, obj_sucursal }) => {
	const navigate = useNavigate();
	const { nit, main_direc, sub_direc } = useParams();
	const [isLoading, setIsLoading] = useState(true);

	const { currentBranch, loadImageS, returnCurrency } = useProveedorCompany();
	const currenRoll = currentBranch?.code ?? "none";

	useEffect(() => {
		if (!array_subdirectorys.includes(sub_direc)) navigate("/error404");
	}, []);
	//permisos?.remove_costo && permisos?.remove_bene ? 4 : 6
	const pageAllow = {
		V2D0: {
			[array_subdirectorys[0]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[3]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true
			},
			[array_subdirectorys[4]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true,
			},
			[array_subdirectorys[9]]: {
				all: true
			},
			[array_subdirectorys[10]]: {
				all: true
			},
			[array_subdirectorys[12]]: {
				all: true
			}
		},
		S3C1: {
			[array_subdirectorys[0]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				remove_costo: true,
				remove_bene: true,
				addMercaderia: true,
				addGastos: true,
				pdf: true,
				edit: true,
				informe_cgc: true,
			},
			[array_subdirectorys[3]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true
			},
			[array_subdirectorys[4]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true,
			},
			[array_subdirectorys[5]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true,
			},
			[array_subdirectorys[9]]: {
				all: true
			},
			[array_subdirectorys[10]]: {
				all: true
			},
			[array_subdirectorys[12]]: {
				all: true
			}
		},
		A1M0: {
			[array_subdirectorys[0]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				remove_costo: true,
				remove_bene: true,
				addMercaderia: true,
				addGastos: true,
				pdf: true,
				edit: true,
				informe_cgc: true,
			},
			[array_subdirectorys[3]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true
			},
			[array_subdirectorys[4]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true,
			},
			[array_subdirectorys[5]]: {
				remove_costo: true,
				remove_bene: true,
				pdf: true,
			},
			[array_subdirectorys[9]]: {
				all: true
			},
			[array_subdirectorys[10]]: {
				all: true
			},
			[array_subdirectorys[11]]: {
				all: true
			},
			[array_subdirectorys[12]]: {
				all: true
			}
		},
		G3R1: {
			[array_subdirectorys[0]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				addMercaderia: true,
				addGastos: true,
				pdf: true,
				edit: true,
				informe: true,
			},
			[array_subdirectorys[3]]: {
				pdf: true
			},
			[array_subdirectorys[4]]: {
				pdf: true,
			},
			[array_subdirectorys[5]]: {
				pdf: true,
			},
			[array_subdirectorys[6]]: {
				pdf: true,
			},
			[array_subdirectorys[7]]: {
				pdf: true,
			},
			[array_subdirectorys[8]]: {
				pdf: true,
			},
			[array_subdirectorys[9]]: {
				all: true
			},
			[array_subdirectorys[10]]: {
				all: true
			},
			[array_subdirectorys[11]]: {
				all: true
			},
			[array_subdirectorys[12]]: {
				all: true
			}
		},
		S4A1: {
			[array_subdirectorys[0]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				addMercaderia: true,
				addGastos: true,
				pdf: true,
				edit: true,
				informe: true,
			},
			[array_subdirectorys[3]]: {
				pdf: true
			},
			[array_subdirectorys[4]]: {
				pdf: true,
			},
			[array_subdirectorys[5]]: {
				pdf: true,
			},
			[array_subdirectorys[6]]: {
				pdf: true,
			},
			[array_subdirectorys[7]]: {
				pdf: true,
			},
			[array_subdirectorys[8]]: {
				pdf: true,
			},
			[array_subdirectorys[9]]: {
				all: true
			},
			[array_subdirectorys[10]]: {
				all: true
			},
			[array_subdirectorys[11]]: {
				all: true
			},
			[array_subdirectorys[12]]: {
				all: true
			}
		},
	};

	const list_components = {
		[array_subdirectorys[0]]: { text: "Venta", icon: venta },
		[array_subdirectorys[1]]: { text: "Cotización", icon: cotizacion },
		[array_subdirectorys[2]]: { text: "Caja", icon: caja },
		[array_subdirectorys[3]]: { text: "Ventas del Día", icon: ventadia },
		[array_subdirectorys[4]]: { text: "Reporte de Ventas", icon: hoja_morada },
		[array_subdirectorys[5]]: { text: "Reporte de Caja", icon: hoja_morada },
		[array_subdirectorys[6]]: { text: "Reporte de compras", icon: hoja_morada },
		[array_subdirectorys[7]]: { text: "Reporte de Inventario", icon: hoja_morada },
		[array_subdirectorys[8]]: { text: "Nota de Caja", icon: hoja_naranja },
		[array_subdirectorys[9]]: { text: "Nota de Ventas", icon: hoja_naranja },
		[array_subdirectorys[10]]: { text: "Nota de Cotización", icon: hoja_naranja },
		[array_subdirectorys[11]]: { text: "Nota de Traslado", icon: hoja_naranja },
		[array_subdirectorys[12]]: { text: "Nota Anulada", icon: hoja_naranja },
	};

	const renderContent = () => {
		if ((!obj_sucursal || obj_sucursal.length === 0) && !sucursal_selected) {
			return <div>No hay sucursales disponibles</div>;
		}

		var allowedForced = null;
		if (currentBranch?.code == "none") return <div> No tienes los permisos suficientes para acceder aquí!</div>

		if (!pageAllow[currenRoll]?.[sub_direc]) {
			if (!pageAllow[currenRoll]) return (<Error404 />);

			const getAllowed = Object.keys(pageAllow[currenRoll]);

			allowedForced = getAllowed[getAllowed.length - 1];
			navigate(`/administrar/venta/${allowedForced}/${nit}`, { replace: true });
		}

		switch (allowedForced ?? sub_direc) {
			case "realizar":
				return <Vventas
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[0]]}
					loadImageS={loadImageS}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "cotizar":
				return <Vcotizacion
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[1]]}
					loadImageS={loadImageS}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "caja":
				return (
					<Vcaja
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[2]]}
						convertPrice={returnCurrency}
						currency={currentBranch?.currency ?? 'BOB'}
					/>
				);
			case "dia":
				return (
					<VventasDia
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[3]]}
						convertPrice={returnCurrency}
						currency={currentBranch?.currency ?? 'BOB'}
					/>
				);
			case "reporte":
				return (
					<VreporteVentas
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[4]]}
						convertPrice={returnCurrency}
						currency={currentBranch?.currency ?? 'BOB'}
					/>
				);
			case "caja-reporte":
				return (
					<VreporteCaja
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[5]]}
						convertPrice={returnCurrency}
						currency={currentBranch?.currency ?? 'BOB'}
					/>
				);

			case "compras-reporte":
				return <VreporteCompras
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[6]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "inventario-reporte":
				return <VreporteInventario
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[7]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "caja-nota":
				return <VnotaCaja
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[8]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "nota":
				return <VnotaVentas
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[9]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "cotizacion-nota":
				return <VnotaCotizacion
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[10]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "traslado-nota":
				return <VnotaTraslado
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[11]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			case "anulados":
				return <VnotaAnuladas
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[12]]}
					convertPrice={returnCurrency}
					currency={currentBranch?.currency ?? 'BOB'}
				/>;
			default:
				return <div>Selecciona una sección</div>;
		}
	};

	const style_modificar = {
		alignItems: 'center',
		background: '#0000',
		border: 'none',
		display: 'flex',
		flexFlow: 'row nowrap',
		gap: '15px',
		height: '60px',
		width: '100%',
	};

	return (
		<div className="contenedor-bodys-products">
			<div className="option-left option-company-left">
				<div className="accion-icons">
					{/* Select de Tienda */}
					<FormControl fullWidth size="small" sx={{ mb: 2, pr: 1 }}>
						<SelectBranchs />
					</FormControl>

					{/* Opciones de navegación - with permission filtering */}
					{(array_subdirectorys ?? []).map((valor, index) =>
						pageAllow[currenRoll]?.[valor] && (
							<NavLink
								key={index}
								// style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
								to={`/administrar/venta/${valor}/${nit}`}
								style={{
									...style_modificar,
									backgroundColor: (sub_direc === valor ? 'rgba(0,0,0,0.1)' : 'transparent')
								}}
							>
								<img src={list_components[valor].icon} alt={list_components[valor].text} style={{ width: 'var(--size-icons-global-company)' }} />
								<span className="normal-black text-bold ">{list_components[valor].text}</span>
							</NavLink>
						)
					)}
				</div>
			</div>

			<div className="floating-menu">
				<button className="default-buttons">
					<MenuIcon sx={{ color: 'var(--theme-company)', fontSize: '50px' }} />
				</button>
				<ul	>
					<div style={{ position: 'absolute', top: '0px', left: '0px', height: '100%', width: '100%', backgroundColor: 'var(--theme-company)', zIndex: 0, opacity: .15, filter: 'blur(15px)' }}></div>
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<li style={{ backgroundColor: (array_subdirectorys[index] == sub_direc ? 'rgba(0,0,0,0.15)' : 'transparent'), zIndex: 2 }}>
									<NavLink
										className={({ isActive }) => ` ${isActive ? "active-product" : ""}`}
										to={`/administrar/venta/${valor}/${nit}`}
										style={style_modificar}
									>
										<Box >
											<img src={list_components[valor]?.icon} alt={list_components[valor]?.text} style={{ width: 'var(--size-icons-global-company)' }} />
										</Box>

										<span style={{ color: 'var(--theme-main)', fontWeight: '500' }}>{list_components[valor]?.text}</span>
									</NavLink>
								</li>
							)
						))
					}
				</ul>
			</div>

			{/* Contenido dinámico */}
			<div className="option-right option-company-right">{renderContent()}</div>
		</div>
	);
};

export default Reportes_EU;
